/** @format */

import axios from 'axios';
import { Campaign, CampaignFormInput, CampaignFilterInput } from '../types';

const apiUrl = process.env.REACT_APP_SIADASH_BACKEND_URL;

/**
 * Get all campaigns
 */
export const getAllCampaigns = async (filter?: CampaignFilterInput): Promise<Campaign[]> => {
  const token = localStorage.getItem('accessToken');
  console.log('Fetching campaigns with filter:', filter);
  const response = await axios.get(`${apiUrl}/api/campaigns`, {
    headers: {
      Authorization: `Bearer ${token}`,
    },
    params: filter,
  });
  console.log('Campaigns fetched:', response.data);
  return response.data;
};

/**
 * Get campaign by ID
 */
export const getCampaignById = async (id: string): Promise<Campaign> => {
  const token = localStorage.getItem('accessToken');
  const response = await axios.get(`${apiUrl}/api/campaigns/${id}`, {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });
  return response.data;
};

/**
 * Get campaigns by office
 */
export const getCampaignsByOffice = async (officeId: string): Promise<Campaign[]> => {
  const token = localStorage.getItem('accessToken');
  const response = await axios.get(`${apiUrl}/api/campaigns/office/${officeId}`, {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });
  return response.data;
};

/**
 * Create a single campaign
 */
export const createCampaign = async (campaign: CampaignFormInput): Promise<Campaign> => {
  const token = localStorage.getItem('accessToken');
  console.log('Creating campaign:', campaign);
  const response = await axios.post(`${apiUrl}/api/campaigns`, campaign, {
    headers: {
      Authorization: `Bearer ${token}`,
      'Content-Type': 'application/json',
    },
  });
  console.log('Campaign created:', response.data);
  return response.data;
};

/**
 * Create multiple campaigns in batch
 */
export const batchCreateCampaigns = async (campaigns: CampaignFormInput[]): Promise<Campaign[]> => {
  const token = localStorage.getItem('accessToken');
  console.log('Submitting campaigns:', campaigns);
  const response = await axios.post(`${apiUrl}/api/campaigns`, campaigns, {
    headers: {
      Authorization: `Bearer ${token}`,
      'Content-Type': 'application/json',
    },
  });
  console.log('Campaigns created:', response.data);
  return response.data;
};

/**
 * Update a campaign
 */
export const updateCampaign = async (id: string, campaign: Partial<CampaignFormInput>): Promise<Campaign> => {
  const token = localStorage.getItem('accessToken');
  const response = await axios.put(`${apiUrl}/api/campaigns/${id}`, campaign, {
    headers: {
      Authorization: `Bearer ${token}`,
      'Content-Type': 'application/json',
    },
  });
  return response.data;
};

/**
 * Delete a campaign
 */
export const deleteCampaign = async (id: string): Promise<Campaign> => {
  const token = localStorage.getItem('accessToken');
  const response = await axios.delete(`${apiUrl}/api/campaigns/${id}`, {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });
  return response.data;
};
